import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewEncapsulation } from '@angular/core';
import { EmailAddress } from 'common/store/genesys-cloud/conversations/emails/models/email-address.model';
import { EmailMessage } from 'common/store/genesys-cloud/conversations/emails/models/email-message.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { WorkItemStateHandler } from 'shared/services/workitem-state-handler/workitem-state-handler.service';
import { CommunicationType } from 'common/store/genesys-cloud/conversations/common/models/communication-type.enum';

@Component({
  selector: 'app-genesys-email-box',
  templateUrl: './genesys-email-box.component.html',
  styleUrls: ['./genesys-email-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class GenesysEmailBoxComponent {
  private readonly onDestroySubject = new Subject<void>();
  readonly communicationTypes = CommunicationType;

  @Input()
  conversationId: string;

  @Input()
  agentParticipantId: string;

  @Input()
  lastEmailMessage: EmailMessage;

  @Input()
  themeClass: string;

  @Input()
  isExpanded: boolean;

  @Input()
  isLastEmailFromCustomer: boolean;

  @Input()
  agentEmailAddress: EmailAddress;

  @Input()
  customerEmailAddresses: EmailAddress[];

  @Input()
  draftEmail: EmailMessage;

  @Input()
  emailError: string;

  @Input()
  isWrapUpRequired: boolean;

  @Input()
  isProactiveEmail: boolean;

  isTransferPanelOpen: boolean;

  constructor(readonly changeDetectorRef: ChangeDetectorRef,
    private readonly workItemStateHandler: WorkItemStateHandler) {
      this.workItemStateHandler.workItemFocused$.pipe(
        takeUntil(this.onDestroySubject)
      ).subscribe(() => changeDetectorRef.detectChanges());
    }

  get isFocused(): boolean {
    return this.workItemStateHandler.isFocused(this.conversationId);
  }

  onTransferPanelOpen(): void {
    this.isTransferPanelOpen = true;
  }

  onTransferPanelCancel(): void {
    this.isTransferPanelOpen = false;
  }
}
